import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
export const Layout = () => import('@/layouts/BasicLayout/index.vue')
export const constantRoutes: Array<RouteRecordRaw> = [
  // {
  //   path: '/',
  //   name: '主页',
  //   redirect: '/ErrorPage/403'
  // },
  {
    path: '/login',
    meta: { hidden: true },
    component: () => import('@/pages/Login/index.vue'),
  },
  // {
  //   path: '/PermissionSystem',
  //   meta: {
  //     icon: 'SetUp',
  //     title: '权限系统',
  //   },
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'UserManage',
  //       name: 'UserManage',
  //       meta: {
  //         icon: 'UserFilled',
  //         title: '用户管理',
  //       },
  //       component: () => import('@/pages/PermissionSystem/UserManage/index.vue'),
  //     },
  //     {
  //       path: 'RolesManage',
  //       name: 'RolesManage',
  //       meta: {
  //         icon: 'Folder',
  //         title: '角色管理',
  //       },
  //       component: () => import('@/pages/PermissionSystem/RolesManage/index.vue'),
  //     },
  //     {
  //       path: 'MenuManage',
  //       name: 'MenuManage',
  //       meta: {
  //         icon: 'Menu',
  //         title: '菜单管理',
  //       },
  //       component: () => import('@/pages/PermissionSystem/MenuManage/index.vue'),
  //     },
  //   ],
  // },
  {
    path: '/ErrorPage',
    component: Layout,
    meta: {
      hidden: true,
      title: '错误页面',
    },
    children: [
      {
        path: '403',
        meta: {
          title: '403',
        },
        component: () => import('@/components/ErrorPage/403.vue'),
      },
      {
        path: '404',
        meta: {
          title: '404',
        },
        component: () => import('@/components/ErrorPage/404.vue'),
      },
      {
        path: '500',
        meta: {
          title: '500',
        },
        component: () => import('@/components/ErrorPage/500.vue'),
      },
    ],
  },
]
const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes as RouteRecordRaw[],
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

export default router
